import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeDunningPlanCreate,
  detail: routeDunningPlanDetail,
  home: routeDunningPlanHome,
  root: routeDunningPlanRoot,
} = createDoctypeRoutes({
  createName: 'new-dunning-plan',
  createPath: 'new-dunning-plan',
  detailName: 'dunningPlanDetail',
  doctype: DOCTYPES.DUNNING_PLAN,
  homeName: 'dunning-plan-home',
  path: 'dunning-plan',
  views: {
    create: async () => await import('@/components/viewsExternal/dunningPlans/AddDunningPlan.vue'),
    detail: async () => await import('@/components/viewsExternal/dunningPlans/ViewDunningPlan.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
  },
})

export {
  routeDunningPlanCreate,
  routeDunningPlanDetail,
  routeDunningPlanHome,
  routeDunningPlanRoot,
}
